/**
 * Single source of truth for everything that isn't layout: names, numbers,
 * links, opening hours, copy blocks. Non-developers can edit this file safely.
 */

export const SITE = {
  name: 'The Local',
  legalName: 'The Local Cafe, Bar & Restaurant',
  established: 2020,
  city: 'Kampala',
  country: 'Uganda',
  url: 'https://www.wethelocal.co',
  tagline: 'Every dish is a moment shared.',
  shortDescription:
    'A Ugandan-inspired cafe, bar and restaurant in Kampala. Bold flavour, a fresh take on tradition, and a table that always has room for one more.',
};

export const NAV = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/whats-on', label: "What's On" },
  { to: '/menus', label: 'Menus' },
  { to: '/bookings', label: 'Bookings' },
  { to: '/contact', label: 'Contact' },
];

export const LOCATIONS = [
  {
    id: 'bugolobi',
    name: 'Bugolobi',
    strapline: 'The original room.',
    phone: '0776077093',
    phoneIntl: '+256776077093',
    // Google's "search" deep link. Resolves from the query on every platform
    // and never rots, unlike a maps.app.goo.gl short link tied to one pin.
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=' +
      encodeURIComponent('The Local Bugolobi, Kampala, Uganda'),
    area: 'Bugolobi, Kampala',
    note: 'Long lunches, louder evenings, and the corner table everyone asks for.',
    welcome: 'Welcome to The Local, Bugolobi — your new favourite spot to eat, sip and vibe.',
    hours: [
      { days: 'Monday – Thursday', time: '9:00am – 11:00pm' },
      { days: 'Friday – Saturday', time: '9:00am – late' },
      { days: 'Sunday', time: '12:00pm – 10:00pm' },
    ],
  },
  {
    id: 'kyanja',
    name: 'Kyanja',
    strapline: 'The neighbourhood one.',
    phone: '0764404997',
    phoneIntl: '+256764404997',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=' +
      encodeURIComponent('The Local Kyanja, Kampala, Uganda'),
    area: 'Kyanja, Kampala',
    note: 'Slower mornings, garden light, and Sundays that stretch.',
    welcome: 'Welcome to The Local, Kyanja — your new favourite spot to eat, sip and vibe.',
    hours: [
      { days: 'Monday – Thursday', time: '9:00am – 11:00pm' },
      { days: 'Friday – Saturday', time: '9:00am – late' },
      { days: 'Sunday', time: '12:00pm – 10:00pm' },
    ],
  },
];

export const getLocation = (slug) => LOCATIONS.find((l) => l.id === slug);

export const SOCIALS = [
  { id: 'instagram', label: 'Instagram', handle: '@thelocalug', url: 'https://www.instagram.com/thelocalug/' },
  { id: 'x', label: 'X', handle: '@thelocalug', url: 'https://x.com/thelocalug' },
  { id: 'tiktok', label: 'TikTok', handle: '@thelocalug', url: 'https://www.tiktok.com/@thelocalug' },
];

/** Ordering + delivery runs on Izi (IziFood). */
export const IZI = {
  brand: 'iZi Food',
  web: 'https://izifood.co',
  android: 'https://play.google.com/store/apps/details?id=com.izifood.app',
  // TODO: paste the real App Store URL once the iOS build is live. Left empty
  // on purpose — the badge hides itself rather than shipping a dead link.
  // (Searching turned up other apps called "iZiFood"; none of them are ours.)
  ios: '',
  blurb:
    'Order The Local straight to your door — or collect on your way home. Live order tracking, saved favourites, and riders who know Kampala.',
  steps: [
    { n: '01', title: 'Pick your branch', body: 'Bugolobi or Kyanja — whichever is closer to you tonight.' },
    { n: '02', title: 'Build your order', body: 'The full menu, exactly as it comes to the table.' },
    { n: '03', title: 'Track it to the door', body: 'Live rider tracking from our kitchen to your gate.' },
  ],
};

/** Copy blocks, kept out of the components. */
export const COPY = {
  heroEyebrow: 'Cafe · Bar · Restaurant',
  heroLead:
    'The Local opens its doors with bold Ugandan flavour and a fresh take on tradition.',
  introHeading: 'We celebrate good food and easy moments, mixing comfort, creativity and community.',
  introBody:
    'Our menu is inspired by the everyday Ugandan table, reimagined with creativity and care. It’s all about seasonality, simplicity and soul — served in a way that feels familiar but tastes like something new.',
  philosophyHeading: 'We celebrate good food and easy moments.',
  philosophyBody:
    'Our kitchens lean into the comfort of familiar flavours. Dishes that feel like home but still surprise you. Meals cooked with the kind of care you can taste. Nothing overthought. Nothing overpolished. Just honest food that brings people together without trying too hard.',
  aboutHeading: 'A local escape for cocktails and dining in your neighbourhood.',
  aboutOpener:
    'The Local was built on a simple idea. Food tastes better when it feels like it belongs to the neighbourhood. Not fancy belonging. Real belonging.',
  aboutMission:
    'We exist to make those small, everyday moments feel a little bigger, a little warmer, and a lot more delicious.',
  aboutMenuLine: 'Menus shaped by our city, our people and the moments we share.',
  contactLead: 'However big or small your request, our team would love to hear from you.',
};

export const VALUES = [
  {
    n: '01',
    title: 'Of the neighbourhood',
    body: 'We cook for the people who walk past every day, not for a guidebook. The room should feel like yours before the food arrives.',
  },
  {
    n: '02',
    title: 'Familiar, then surprising',
    body: 'Everything starts at the everyday Ugandan table. Then we ask one question — what if this were a little better?',
  },
  {
    n: '03',
    title: 'Nothing overpolished',
    body: 'Care you can taste, without the ceremony. Generous plates, honest prices, and a bar that knows your order.',
  },
];

export const MARQUEE = [
  'Bugolobi',
  'Kyanja',
  'Slow Sundays',
  'Taco Tuesday',
  'Happy Hour',
  'Burger Mondays',
  'Est. 2020',
];
